import { useEffect, useRef } from 'react';
import { notifyParent } from './notifyIframe';

let previousHeight: number;

export function notifyIframeHeight(minHeight = 0) {
  const iframeMinHeight = Math.max(minHeight, window.POLL_MIN_HEIGHT ?? 0, 0);
  const content = document.getElementById('content');

  let contentHeight: string | null = null;
  let contentScrollTop = 0;

  if (content && content.style.height) {
    contentHeight = content.style.height;
    contentScrollTop = content.scrollTop;
    content.style.height = 'auto';
  }

  const height = content ? calculateContentHeight(content) + getTimerHeight() : NaN;

  if (content && contentHeight) {
    content.style.height = contentHeight;
    content.scrollTop = contentScrollTop;
  }

  if (isNaN(height) || height === previousHeight) {
    return;
  }

  previousHeight = height;

  if (height !== 0) notifyParent({ type: 'survey_iframe_height', height: Math.max(iframeMinHeight, height) });
}

export function useTimerHeightObserver(updateTimerHeight: (height: number) => void) {
  const timerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let lastTimerHeight = 0;
    const observer = new ResizeObserver(() => {
      const timerHeight = getTimerHeight();
      if (lastTimerHeight !== timerHeight) {
        notifyIframeHeight();
        lastTimerHeight = timerHeight;
        updateTimerHeight(timerHeight);
      }
    });

    if (timerRef.current) observer.observe(timerRef.current);
    return () => {
      observer.disconnect();
    };
  }, []);

  return timerRef;
}

export function getTimerHeight() {
  const timer = document.getElementById('timer');
  if (!timer) return 0;
  return calculateContentHeight(timer) + 16 + (document.body.id === 'PollsSite' ? 0 : 16);
}

/** Свойство scrollHeight возвращет целочисленное значение, которого недостаточно */
function calculateContentHeight(content: HTMLElement) {
  if (content == null) return NaN;

  let calculatedHeight = 0;
  const scrollHeight = content.scrollHeight;
  Array.prototype.forEach.call(content.children, (child: Element) => {
    calculatedHeight += child.getBoundingClientRect().height;
  });

  if (Math.abs(scrollHeight - calculatedHeight) < 1) return calculatedHeight;
  return scrollHeight;
}
